import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutPage from '../AboutPage/AboutPage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import FaqPage from '../FaqPage/FaqPage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectSingle from '../ProjectSingle/ProjectSingle';
import ServicePages from '../ServicePage/ServicePage';
import ServicePageV2 from '../ServicePageV2/ServicePageV2';
import ConditionsPage from '../ConditionsPage/ConditionsPage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogDetails from '../BlogDetails/BlogDetails'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import InternationalPage from '../InternationalPage/InternationalPage';
import PrivacyPage from '../PrivacyPage/PrivacyPage';
import TermsPage from '../TermsPage/TermsPage';
import PatientFormsPage from '../PatientFormsPage/PatientFormsPage';

// Admin Panel
import { AuthProvider } from '../../hooks/useAuth';
import {
  ProtectedRoute,
  LoginPage,
  DashboardPage,
  PostsPage,
  PostEditorPage,
  CategoriesPage,
  AuthorsPage,
  MediaPage,
  UsersPage
} from '../../admin';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage2 />} />
            <Route path="home" element={<HomePage2 />} />
            <Route path="home-2" element={<HomePage2 />} />
            <Route path="home-3" element={<HomePage3 />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="team-single/:slug" element={<TeamSinglePage />} />
            <Route path="faq" element={<FaqPage/>} />
            <Route path="services" element={<ServicePages/>} />
            <Route path="treatments" element={<ServicePageV2/>} />
            <Route path="service-single/:slug" element={<ServiceSinglePage />} />
            <Route path="project" element={<ProjectPage/>} />
            <Route path="conditions" element={<ConditionsPage/>} />
            <Route path="project-single/:slug" element={<ProjectSingle />} />
            <Route path='blog' element={<BlogPage/>} />
            <Route path='blog/:slug' element={<BlogDetails />} />
            <Route path='contact' element={<ContactPage />} />
            <Route path='international' element={<InternationalPage />} />
            <Route path='privacy' element={<PrivacyPage />} />
            <Route path='terms' element={<TermsPage />} />
            <Route path='patient-forms' element={<PatientFormsPage />} />

            {/* Admin Routes */}
            <Route path="admin/login" element={<LoginPage />} />
            <Route path="admin" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="admin/posts" element={<ProtectedRoute><PostsPage /></ProtectedRoute>} />
            <Route path="admin/posts/new" element={<ProtectedRoute><PostEditorPage /></ProtectedRoute>} />
            <Route path="admin/posts/:id" element={<ProtectedRoute><PostEditorPage /></ProtectedRoute>} />
            <Route path="admin/categories" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
            <Route path="admin/authors" element={<ProtectedRoute><AuthorsPage /></ProtectedRoute>} />
            <Route path="admin/media" element={<ProtectedRoute><MediaPage /></ProtectedRoute>} />
            <Route path="admin/users" element={<ProtectedRoute requiredRoles={['admin']}><UsersPage /></ProtectedRoute>} />

            <Route path='*' element={<ErrorPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
